<script setup lang="ts">
import { computed } from 'vue';

import { PoolNote } from '@/types/untangled/pool';
import instance from '@/services/api/untangled-axios';
import useNumbers from '@/composables/useNumbers';
import { calculateApy } from '@/lib/utils/util.service';

/**
 * TYPES
 */
type Props = {
  poolNote: PoolNote;
};

/**
 * PROPS & EMITS
 */
const props = defineProps<Props>();

/**
 * COMPOSABLES
 */
const { fNum } = useNumbers();
const targetReturnNotification = ref();
const loading = ref(false);

watchEffect(async () => {
  loading.value = true;
  const poolId = props.poolNote.poolId;
  const { data } = await instance.get(`/api/v1/pool-migration/${poolId}`);
  loading.value = false;
  const _apr = data?.data?.poolNotification?.apr?.published;

  targetReturnNotification.value = _apr?.content;
});

/** COMPUTED */
const targetReturn = computed(() => {
  if (targetReturnNotification.value) {
    return targetReturnNotification.value;
  }

  return props.poolNote.targetAmount
    ? `${fNum(calculateApy(props.poolNote), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} %`
    : 'Variable';
});
</script>

<template>
  <div :class="['flex justify-end py-4 px-6 -mt-1 font-numeric text-right']">
    <BalLoadingBlock v-if="loading" class="w-12 h-4" />
    <span v-else v-html="targetReturn" />
  </div>
</template>
